import type { ConsiderationRiskStatus } from '~kui/utils/considerationRiskStatus';

import { CONSIDERATION_RISK_STATUS } from '~kui/utils/considerationRiskStatus';

import { ConsiderationScoreRisk } from '~/graphql/generated/graphql';

/**
 * The GraphQL `ConsiderationScoreRisk` enum is UPPERCASE (`LOW`), while KUI's `ConsiderationRiskStatus`
 * is the lowercase value its copy keys use. The shared CDP snapshot carries the same value as a plain
 * string. A missing or unknown risk reads as high, the band a student with no score sits in.
 */
export const toConsiderationRiskStatus = (risk: string | null | undefined): ConsiderationRiskStatus => {
  switch (risk) {
    case ConsiderationScoreRisk.Low:
      return CONSIDERATION_RISK_STATUS.Low;
    case ConsiderationScoreRisk.Medium:
      return CONSIDERATION_RISK_STATUS.Medium;
    default:
      return CONSIDERATION_RISK_STATUS.High;
  }
};
